import * as React from "react";
const IconHappy4 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
    <path d="M44.4 40.6c-.6 0-1 .4-1 1 0 2.9-2.3 5.2-5.2 5.2S33 44.5 33 41.6c0-.6-.4-1-1-1s-1 .4-1 1c0 2.9-2.3 5.2-5.2 5.2s-5.2-2.3-5.2-5.2c0-.6-.4-1-1-1s-1 .4-1 1c0 4 3.2 7.2 7.2 7.2 2.6 0 4.9-1.4 6.2-3.5 1.3 2.1 3.6 3.5 6.2 3.5 4 0 7.2-3.2 7.2-7.2 0-.5-.5-1-1-1M24.3 23c0-2.1-1.7-3.9-3.9-3.9-2.1 0-3.9 1.7-3.9 3.9 0 2.1 1.7 3.9 3.9 3.9 2.1 0 3.9-1.8 3.9-3.9M43.6 19.1c-2.1 0-3.9 1.7-3.9 3.9 0 2.1 1.7 3.9 3.9 3.9 2.1 0 3.9-1.7 3.9-3.9-.1-2.1-1.8-3.9-3.9-3.9" />
  </svg>
);
export default IconHappy4;
